var $2oePb$reactstatelycollections = require("@react-stately/collections");
var $2oePb$reactstatelyvirtualizer = require("@react-stately/virtualizer");
var $2oePb$reactariautils = require("@react-aria/utils");
var $2oePb$react = require("react");
var $2oePb$reactariai18n = require("@react-aria/i18n");
var $2oePb$reactariafocus = require("@react-aria/focus");
var $2oePb$reactariaselection = require("@react-aria/selection");
var $2oePb$reactarialiveannouncer = require("@react-aria/live-announcer");
var $2oePb$reactariainteractions = require("@react-aria/interactions");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "GridKeyboardDelegate", () => $3187c0e19200cb16$export$de9feff04fda126e);
$parcel$export(module.exports, "useGrid", () => $11d770dfabe45077$export$f6b86a04e5d66d90);
$parcel$export(module.exports, "useGridRowGroup", () => $c7def85a57100898$export$d3037f5d3f3e51bf);
$parcel$export(module.exports, "useGridRow", () => $eed398987c639831$export$96357d5a73f686fa);
$parcel$export(module.exports, "useGridCell", () => $cf2021be63b01ef4$export$c7e10bfc0c59f67c);
$parcel$export(module.exports, "useGridSelectionCheckbox", () => $d8385f73d3701365$export$70e2eed1a92976ad);
$parcel$export(module.exports, "useHighlightSelectionDescription", () => $340f2fcd0ef9ce8d$export$be42ebdab07ae4c2);
$parcel$export(module.exports, "useGridSelectionAnnouncement", () => $1eb174acfe8a0f16$export$137e594ef3218a10);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

class $3187c0e19200cb16$export$de9feff04fda126e {
  isCell(node) {
    return node.type === "cell";
  }
  isRow(node) {
    return node.type === "row" || node.type === "item";
  }
  findPreviousKey(fromKey, pred) {
    let key = fromKey != null ? this.collection.getKeyBefore(fromKey) : this.collection.getLastKey();
    while (key != null) {
      let item = this.collection.getItem(key);
      if (!this.disabledKeys.has(key) && (!pred || pred(item))) return key;
      key = this.collection.getKeyBefore(key);
    }
  }
  findNextKey(fromKey, pred) {
    let key = fromKey != null ? this.collection.getKeyAfter(fromKey) : this.collection.getFirstKey();
    while (key != null) {
      let item = this.collection.getItem(key);
      if (!this.disabledKeys.has(key) && (!pred || pred(item))) return key;
      key = this.collection.getKeyAfter(key);
    }
  }
  getKeyBelow(key) {
    let startItem = this.collection.getItem(key);
    if (!startItem) return;
    // If focus was on a cell, start searching from the parent row
    if (this.isCell(startItem)) key = startItem.parentKey;
    // Find the next item
    key = this.findNextKey(key);
    if (key != null) {
      // If focus was on a cell, focus the cell with the same index in the next row.
      if (this.isCell(startItem)) {
        let item = this.collection.getItem(key);
        return (0, $2oePb$reactstatelycollections.getNthItem)((0, $2oePb$reactstatelycollections.getChildNodes)(item, this.collection), startItem.index).key;
      }
      // Otherwise, focus the next row
      if (this.focusMode === "row") return key;
    }
  }
  getKeyAbove(key) {
    let startItem = this.collection.getItem(key);
    if (!startItem) return;
    // If focus is on a cell, start searching from the parent row
    if (this.isCell(startItem)) key = startItem.parentKey;
    // Find the previous item
    key = this.findPreviousKey(key);
    if (key != null) {
      // If focus was on a cell, focus the cell with the same index in the previous row.
      if (this.isCell(startItem)) {
        let item = this.collection.getItem(key);
        return (0, $2oePb$reactstatelycollections.getNthItem)((0, $2oePb$reactstatelycollections.getChildNodes)(item, this.collection), startItem.index).key;
      }
      // Otherwise, focus the previous row
      if (this.focusMode === "row") return key;
    }
  }
  getKeyRightOf(key) {
    let item = this.collection.getItem(key);
    if (!item) return;
    // If focus is on a row, focus the first child cell.
    if (this.isRow(item)) {
      let children = (0, $2oePb$reactstatelycollections.getChildNodes)(item, this.collection);
      return this.direction === "rtl" ? (0, $2oePb$reactstatelycollections.getLastItem)(children).key : (0, $2oePb$reactstatelycollections.getFirstItem)(children).key;
    }
    // If focus is on a cell, focus the next cell if any,
    // otherwise focus the parent row.
    if (this.isCell(item)) {
      let parent = this.collection.getItem(item.parentKey);
      let children = (0, $2oePb$reactstatelycollections.getChildNodes)(parent, this.collection);
      let next = this.direction === "rtl" ? (0, $2oePb$reactstatelycollections.getNthItem)(children, item.index - 1) : (0, $2oePb$reactstatelycollections.getNthItem)(children, item.index + 1);
      if (next) return next.key;
      // focus row only if focusMode is set to row
      if (this.focusMode === "row") return item.parentKey;
      return this.direction === "rtl" ? this.getFirstKey(key) : this.getLastKey(key);
    }
  }
  getKeyLeftOf(key) {
    let item = this.collection.getItem(key);
    if (!item) return;
    // If focus is on a row, focus the last child cell.
    if (this.isRow(item)) {
      let children = (0, $2oePb$reactstatelycollections.getChildNodes)(item, this.collection);
      return this.direction === "rtl" ? (0, $2oePb$reactstatelycollections.getFirstItem)(children).key : (0, $2oePb$reactstatelycollections.getLastItem)(children).key;
    }
    // If focus is on a cell, focus the previous cell if any,
    // otherwise focus the parent row.
    if (this.isCell(item)) {
      let parent = this.collection.getItem(item.parentKey);
      let children = (0, $2oePb$reactstatelycollections.getChildNodes)(parent, this.collection);
      let prev = this.direction === "rtl" ? (0, $2oePb$reactstatelycollections.getNthItem)(children, item.index + 1) : (0, $2oePb$reactstatelycollections.getNthItem)(children, item.index - 1);
      if (prev) return prev.key;
      // focus row only if focusMode is set to row
      if (this.focusMode === "row") return item.parentKey;
      return this.direction === "rtl" ? this.getLastKey(key) : this.getFirstKey(key);
    }
  }
  getFirstKey(key, global) {
    let item;
    if (key != null) {
      item = this.collection.getItem(key);
      if (!item) return;
      // If global flag is not set, and a cell is currently focused,
      // move focus to the first cell in the parent row.
      if (this.isCell(item) && !global) {
        let parent = this.collection.getItem(item.parentKey);
        return (0, $2oePb$reactstatelycollections.getFirstItem)((0, $2oePb$reactstatelycollections.getChildNodes)(parent, this.collection)).key;
      }
    }
    // Find the first row
    key = this.findNextKey();
    // If global flag is set (or if focus mode is cell), focus the first cell in the first row.
    if (key != null && item && this.isCell(item) && global || this.focusMode === "cell") {
      let item = this.collection.getItem(key);
      key = (0, $2oePb$reactstatelycollections.getFirstItem)((0, $2oePb$reactstatelycollections.getChildNodes)(item, this.collection)).key;
    }
    // Otherwise, focus the row itself.
    return key;
  }
  getLastKey(key, global) {
    let item;
    if (key != null) {
      item = this.collection.getItem(key);
      if (!item) return;
      // If global flag is not set, and a cell is currently focused,
      // move focus to the last cell in the parent row.
      if (this.isCell(item) && !global) {
        let parent = this.collection.getItem(item.parentKey);
        let children = (0, $2oePb$reactstatelycollections.getChildNodes)(parent, this.collection);
        return (0, $2oePb$reactstatelycollections.getLastItem)(children).key;
      }
    }
    // Find the last row
    key = this.findPreviousKey();
    // If global flag is set (or if focus mode is cell), focus the last cell in the last row.
    if (key != null && item && this.isCell(item) && global || this.focusMode === "cell") {
      let item = this.collection.getItem(key);
      let children = (0, $2oePb$reactstatelycollections.getChildNodes)(item, this.collection);
      key = (0, $2oePb$reactstatelycollections.getLastItem)(children).key;
    }
    // Otherwise, focus the row itself.
    return key;
  }
  getItem(key) {
    return this.ref.current.querySelector("[data-key=\"".concat(key, "\"]"));
  }
  getItemRect(key) {
    var _this_layout_getLayoutInfo;
    if (this.layout) return (_this_layout_getLayoutInfo = this.layout.getLayoutInfo(key)) === null || _this_layout_getLayoutInfo === void 0 ? void 0 : _this_layout_getLayoutInfo.rect;
    let item = this.getItem(key);
    if (item) return new (0, $2oePb$reactstatelyvirtualizer.Rect)(item.offsetLeft, item.offsetTop, item.offsetWidth, item.offsetHeight);
  }
  getPageHeight() {
    var _this_layout_virtualizer, _this_ref, _this_ref_current;
    if (this.layout) return (_this_layout_virtualizer = this.layout.virtualizer) === null || _this_layout_virtualizer === void 0 ? void 0 : _this_layout_virtualizer.visibleRect.height;
    return (_this_ref = this.ref) === null || _this_ref === void 0 ? void 0 : (_this_ref_current = _this_ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.offsetHeight;
  }
  getContentHeight() {
    var _this_ref, _this_ref_current;
    if (this.layout) return this.layout.getContentSize().height;
    return (_this_ref = this.ref) === null || _this_ref === void 0 ? void 0 : (_this_ref_current = _this_ref.current) === null || _this_ref_current === void 0 ? void 0 : _this_ref_current.scrollHeight;
  }
  getKeyPageAbove(key) {
    let itemRect = this.getItemRect(key);
    if (!itemRect) return null;
    let pageY = Math.max(0, itemRect.maxY - this.getPageHeight());
    while (itemRect && itemRect.y > pageY) {
      key = this.getKeyAbove(key);
      itemRect = this.getItemRect(key);
    }
    return key;
  }
  getKeyPageBelow(key) {
    let itemRect = this.getItemRect(key);
    if (!itemRect) return null;
    let pageHeight = this.getPageHeight();
    let pageY = Math.min(this.getContentHeight(), itemRect.y + pageHeight);
    while (itemRect && itemRect.maxY < pageY) {
      let nextKey = this.getKeyBelow(key);
      itemRect = this.getItemRect(nextKey);
      // Guard against case where maxY of the last key is barely less than pageY due to rounding
      // and thus it attempts to set key to null
      if (nextKey != null) key = nextKey;
    }
    return key;
  }
  getKeyForSearch(search, fromKey) {
    if (!this.collator) return null;
    let collection = this.collection;
    let key = fromKey !== null && fromKey !== void 0 ? fromKey : this.getFirstKey();
    // If the starting key is a cell, search from its parent row.
    let startItem = collection.getItem(key);
    if (startItem.type === "cell") key = startItem.parentKey;
    let hasWrapped = false;
    while (key != null) {
      let item = collection.getItem(key);
      // check row text value for match
      if (item.textValue) {
        let substring = item.textValue.slice(0, search.length);
        if (this.collator.compare(substring, search) === 0) {
          if (this.isRow(item) && this.focusMode === "cell") return (0, $2oePb$reactstatelycollections.getFirstItem)((0, $2oePb$reactstatelycollections.getChildNodes)(item, this.collection)).key;
          return item.key;
        }
      }
      key = this.findNextKey(key);
      // Wrap around when reaching the end of the collection
      if (key == null && !hasWrapped) {
        key = this.getFirstKey();
        hasWrapped = true;
      }
    }
    return null;
  }
  constructor(options) {
    this.collection = options.collection;
    this.disabledKeys = options.disabledKeys;
    this.ref = options.ref;
    this.direction = options.direction;
    this.collator = options.collator;
    this.layout = options.layout;
    this.focusMode = options.focusMode || "row";
  }
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
const $8ee34951196858d0$export$e6235c0d09b995d0 = new WeakMap();

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $085250522aa37816$exports = {};
var $6f42661ae0214332$exports = {};
$6f42661ae0214332$exports = {
  "deselectedItem": args => "".concat(args.item, " \u063A\u064A\u0631 \u0627\u0644\u0645\u062D\u062F\u062F"),
  "longPressToSelect": "\u0627\u0636\u063A\u0637 \u0645\u0637\u0648\u0644\u064B\u0627 \u0644\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0648\u0636\u0639 \u0627\u0644\u062A\u062D\u062F\u064A\u062F.",
  "select": "\u062A\u062D\u062F\u064A\u062F",
  "selectedAll": "\u062C\u0645\u064A\u0639 \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062D\u062F\u062F\u0629.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u0644\u0645 \u064A\u062A\u0645 \u062A\u062D\u062F\u064A\u062F \u0639\u0646\u0627\u0635\u0631",
    one: () => "".concat(formatter.number(args.count), " \u0639\u0646\u0635\u0631 \u0645\u062D\u062F\u062F"),
    other: () => "".concat(formatter.number(args.count), " \u0639\u0646\u0635\u0631 \u0645\u062D\u062F\u062F")
  }), "."),
  "selectedItem": args => "".concat(args.item, " \u0627\u0644\u0645\u062D\u062F\u062F")
};
var $3e5d289b19f0fad9$exports = {};
$3e5d289b19f0fad9$exports = {
  "deselectedItem": args => "".concat(args.item, " \u043D\u0435 \u0435 \u0438\u0437\u0431\u0440\u0430\u043D."),
  "longPressToSelect": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u0438 \u0437\u0430\u0434\u0440\u044A\u0436\u0442\u0435 \u0437\u0430 \u0434\u0430 \u0432\u043B\u0435\u0437\u0435\u0442\u0435 \u0432 \u0438\u0437\u0431\u0438\u0440\u0430\u0442\u0435\u043B\u0435\u043D \u0440\u0435\u0436\u0438\u043C.",
  "select": "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435",
  "selectedAll": "\u0412\u0441\u0438\u0447\u043A\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u0441\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u041D\u044F\u043C\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438",
    one: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D \u0435\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438")
  }), "."),
  "selectedItem": args => "".concat(args.item, " \u0438\u0437\u0431\u0440\u0430\u043D.")
};
var $786c35956e916979$exports = {};
$786c35956e916979$exports = {
  "deselectedItem": args => "Polo\u017Eka ".concat(args.item, " nen\xED vybr\xE1na."),
  "longPressToSelect": "Dlouh\xFDm stisknut\xEDm p\u0159ejdete do re\u017Eimu v\xFDb\u011Bru.",
  "select": "Vybrat",
  "selectedAll": "Vybr\xE1ny v\u0161echny polo\u017Eky.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Nevybr\xE1ny \u017E\xE1dn\xE9 polo\u017Eky",
    one: () => "Vybr\xE1na ".concat(formatter.number(args.count), " polo\u017Eka"),
    other: () => "Vybr\xE1no ".concat(formatter.number(args.count), " polo\u017Eek")
  }), "."),
  "selectedItem": args => "Vybr\xE1na polo\u017Eka ".concat(args.item, ".")
};
var $7166f564b8fa3e8a$exports = {};
$7166f564b8fa3e8a$exports = {
  "deselectedItem": args => "".concat(args.item, " ikke valgt."),
  "longPressToSelect": "Lav et langt tryk for at aktivere valgtilstand.",
  "select": "V\xE6lg",
  "selectedAll": "Alle elementer valgt.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Ingen elementer valgt",
    one: () => "".concat(formatter.number(args.count), " element valgt"),
    other: () => "".concat(formatter.number(args.count), " elementer valgt")
  }), "."),
  "selectedItem": args => "".concat(args.item, " valgt.")
};
var $12fc5e32bb482de0$exports = {};
$12fc5e32bb482de0$exports = {
  "deselectedItem": args => "".concat(args.item, " nicht ausgew\xE4hlt."),
  "longPressToSelect": "Gedr\xFCckt halten, um Auswahlmodus zu \xF6ffnen.",
  "select": "Ausw\xE4hlen",
  "selectedAll": "Alle Elemente ausgew\xE4hlt.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Keine Elemente ausgew\xE4hlt",
    one: () => "".concat(formatter.number(args.count), " Element ausgew\xE4hlt"),
    other: () => "".concat(formatter.number(args.count), " Elemente ausgew\xE4hlt")
  }), "."),
  "selectedItem": args => "".concat(args.item, " ausgew\xE4hlt.")
};
var $84b67ad15c785b2c$exports = {};
$84b67ad15c785b2c$exports = {
  "deselectedItem": args => "\u0394\u03B5\u03BD \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B5 \u03C4\u03BF \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF ".concat(args.item, "."),
  "longPressToSelect": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C0\u03B1\u03C1\u03B1\u03C4\u03B5\u03C4\u03B1\u03BC\u03AD\u03BD\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BC\u03C0\u03B5\u03AF\u03C4\u03B5 \u03C3\u03B5 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE\u03C2.",
  "select": "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE",
  "selectedAll": "\u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B1\u03BD \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u0394\u03B5\u03BD \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B1\u03BD \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1",
    one: () => "\u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B5 ".concat(formatter.number(args.count), " \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF"),
    other: () => "\u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B1\u03BD ".concat(formatter.number(args.count), " \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1")
  }), "."),
  "selectedItem": args => "\u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B5 \u03C4\u03BF \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF ".concat(args.item, ".")
};
var $86f7e6ba2423a35d$exports = {};
$86f7e6ba2423a35d$exports = {
  "deselectedItem": args => "".concat(args.item, " not selected."),
  "select": "Select",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "No items selected",
    one: () => "".concat(formatter.number(args.count), " item selected"),
    other: () => "".concat(formatter.number(args.count), " items selected")
  }), "."),
  "selectedAll": "All items selected.",
  "selectedItem": args => "".concat(args.item, " selected."),
  "longPressToSelect": "Long press to enter selection mode."
};
var $67f524d2f2545d56$exports = {};
$67f524d2f2545d56$exports = {
  "deselectedItem": args => "".concat(args.item, " no seleccionado."),
  "longPressToSelect": "Mantenga pulsado para abrir el modo de selecci\xF3n.",
  "select": "Seleccionar",
  "selectedAll": "Todos los elementos seleccionados.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Ning\xFAn elemento seleccionado",
    one: () => "".concat(formatter.number(args.count), " elemento seleccionado"),
    other: () => "".concat(formatter.number(args.count), " elementos seleccionados")
  }), "."),
  "selectedItem": args => "".concat(args.item, " seleccionado.")
};
var $d8df13f1dbf6e0c4$exports = {};
$d8df13f1dbf6e0c4$exports = {
  "deselectedItem": args => "".concat(args.item, " pole valitud."),
  "longPressToSelect": "Valikure\u017Eiimi sisenemiseks vajutage pikalt.",
  "select": "Vali",
  "selectedAll": "K\xF5ik \xFCksused valitud.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\xDCksusi pole valitud",
    one: () => "".concat(formatter.number(args.count), " \xFCksus valitud"),
    other: () => "".concat(formatter.number(args.count), " \xFCksust valitud")
  }), "."),
  "selectedItem": args => "".concat(args.item, " valitud.")
};
var $e2b4dfe2d4d55739$exports = {};
$e2b4dfe2d4d55739$exports = {
  "deselectedItem": args => "Kohdetta ".concat(args.item, " ei valittu."),
  "longPressToSelect": "Siirry valintatilaan painamalla pitk\xE4\xE4n.",
  "select": "Valitse",
  "selectedAll": "Kaikki kohteet valittu.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Ei yht\xE4\xE4n kohdetta valittu",
    one: () => "".concat(formatter.number(args.count), " kohde valittu"),
    other: () => "".concat(formatter.number(args.count), " kohdetta valittu")
  }), "."),
  "selectedItem": args => "".concat(args.item, " valittu.")
};
var $c06d6698d30993e7$exports = {};
$c06d6698d30993e7$exports = {
  "deselectedItem": args => "".concat(args.item, " non s\xE9lectionn\xE9."),
  "longPressToSelect": "Appuyez de mani\xE8re prolong\xE9e pour passer en mode de s\xE9lection.",
  "select": "S\xE9lectionner",
  "selectedAll": "Tous les \xE9l\xE9ments s\xE9lectionn\xE9s.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Aucun \xE9l\xE9ment s\xE9lectionn\xE9",
    one: () => "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9"),
    other: () => "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s")
  }), "."),
  "selectedItem": args => "".concat(args.item, " s\xE9lectionn\xE9.")
};
var $e775713aa5566057$exports = {};
$e775713aa5566057$exports = {
  "deselectedItem": args => "".concat(args.item, " \u05DC\u05D0 \u05E0\u05D1\u05D7\u05E8."),
  "longPressToSelect": "\u05D4\u05E7\u05E9\u05D4 \u05D0\u05E8\u05D5\u05DB\u05D4 \u05DC\u05DB\u05E0\u05D9\u05E1\u05D4 \u05DC\u05DE\u05E6\u05D1 \u05D1\u05D7\u05D9\u05E8\u05D4.",
  "select": "\u05D1\u05D7\u05E8",
  "selectedAll": "\u05DB\u05DC \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E0\u05D1\u05D7\u05E8\u05D5.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u05DC\u05D0 \u05E0\u05D1\u05D7\u05E8\u05D5 \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD",
    one: () => "\u05E4\u05E8\u05D9\u05D8 ".concat(formatter.number(args.count), " \u05E0\u05D1\u05D7\u05E8"),
    other: () => "".concat(formatter.number(args.count), " \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E0\u05D1\u05D7\u05E8\u05D5")
  }), "."),
  "selectedItem": args => "".concat(args.item, " \u05E0\u05D1\u05D7\u05E8.")
};
var $a972cfeb69a51f5b$exports = {};
$a972cfeb69a51f5b$exports = {
  "deselectedItem": args => "Stavka ".concat(args.item, " nije odabrana."),
  "longPressToSelect": "Dugo pritisnite za ulazak u na\u010Din odabira.",
  "select": "Odaberite",
  "selectedAll": "Odabrane su sve stavke.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Nije odabrana nijedna stavka",
    one: () => "Odabrana je ".concat(formatter.number(args.count), " stavka"),
    other: () => "Odabrano je ".concat(formatter.number(args.count), " stavki")
  }), "."),
  "selectedItem": args => "Stavka ".concat(args.item, " je odabrana.")
};
var $a471da6bb87e6cd1$exports = {};
$a471da6bb87e6cd1$exports = {
  "deselectedItem": args => "".concat(args.item, " nincs kijel\xF6lve."),
  "longPressToSelect": "Nyomja hosszan a kijel\xF6l\xE9shez.",
  "select": "Kijel\xF6l\xE9s",
  "selectedAll": "Az \xF6sszes elem kijel\xF6lve.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Egy elem sincs kijel\xF6lve",
    one: () => "".concat(formatter.number(args.count), " elem kijel\xF6lve"),
    other: () => "".concat(formatter.number(args.count), " elem kijel\xF6lve")
  }), "."),
  "selectedItem": args => "".concat(args.item, " kijel\xF6lve.")
};
var $47879155027d6c95$exports = {};
$47879155027d6c95$exports = {
  "deselectedItem": args => "".concat(args.item, " non selezionato."),
  "longPressToSelect": "Premi a lungo per passare alla modalit\xE0 di selezione.",
  "select": "Seleziona",
  "selectedAll": "Tutti gli elementi selezionati.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Nessun elemento selezionato",
    one: () => "".concat(formatter.number(args.count), " elemento selezionato"),
    other: () => "".concat(formatter.number(args.count), " elementi selezionati")
  }), "."),
  "selectedItem": args => "".concat(args.item, " selezionato.")
};
var $9cd8dc003c2209e6$exports = {};
$9cd8dc003c2209e6$exports = {
  "deselectedItem": args => "".concat(args.item, " \u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002"),
  "longPressToSelect": "\u9577\u62BC\u3057\u3057\u3066\u9078\u629E\u30E2\u30FC\u30C9\u3092\u958B\u304D\u307E\u3059\u3002",
  "select": "\u9078\u629E",
  "selectedAll": "\u3059\u3079\u3066\u306E\u9805\u76EE\u3092\u9078\u629E\u3057\u307E\u3057\u305F\u3002",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u9805\u76EE\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    one: () => "".concat(formatter.number(args.count), " \u9805\u76EE\u3092\u9078\u629E\u3057\u307E\u3057\u305F"),
    other: () => "".concat(formatter.number(args.count), " \u9805\u76EE\u3092\u9078\u629E\u3057\u307E\u3057\u305F")
  }), "\u3002"),
  "selectedItem": args => "".concat(args.item, " \u3092\u9078\u629E\u3057\u307E\u3057\u305F\u3002")
};
var $a490b9448c5f2ded$exports = {};
$a490b9448c5f2ded$exports = {
  "deselectedItem": args => "".concat(args.item, "\uC774(\uAC00) \uC120\uD0DD\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4."),
  "longPressToSelect": "\uC120\uD0DD \uBAA8\uB4DC\uB85C \uB4E4\uC5B4\uAC00\uB824\uBA74 \uAE38\uAC8C \uB204\uB974\uC2ED\uC2DC\uC624.",
  "select": "\uC120\uD0DD",
  "selectedAll": "\uBAA8\uB4E0 \uD56D\uBAA9\uC774 \uC120\uD0DD\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\uC120\uD0DD\uB41C \uD56D\uBAA9\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
    one: () => "".concat(formatter.number(args.count), "\uAC1C \uD56D\uBAA9\uC774 \uC120\uD0DD\uB418\uC5C8\uC2B5\uB2C8\uB2E4"),
    other: () => "".concat(formatter.number(args.count), "\uAC1C \uD56D\uBAA9\uC774 \uC120\uD0DD\uB418\uC5C8\uC2B5\uB2C8\uB2E4")
  }), "."),
  "selectedItem": args => "".concat(args.item, "\uC774(\uAC00) \uC120\uD0DD\uB418\uC5C8\uC2B5\uB2C8\uB2E4.")
};
var $99f69e0597841328$exports = {};
$99f69e0597841328$exports = {
  "deselectedItem": args => "".concat(args.item, " nepasirinkta."),
  "longPressToSelect": "Nor\u0117dami \u012Fjungti pasirinkimo re\u017Eim\u0105, paspauskite ir palaikykite.",
  "select": "Pasirinkti",
  "selectedAll": "Pasirinkti visi elementai.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Nepasirinktas n\u0117 vienas elementas",
    one: () => "Pasirinktas ".concat(formatter.number(args.count), " elementas"),
    other: () => "Pasirinkta element\u0173: ".concat(formatter.number(args.count))
  }), "."),
  "selectedItem": args => "Pasirinkta: ".concat(args.item, ".")
};
var $28ac5b31e47d46d4$exports = {};
$28ac5b31e47d46d4$exports = {
  "deselectedItem": args => "Vienums ".concat(args.item, " nav atlas\u012Bts."),
  "longPressToSelect": "Ilgi turiet nospiestu. lai iesl\u0113gtu atlases re\u017E\u012Bmu.",
  "select": "Atlas\u012Bt",
  "selectedAll": "Atlas\u012Bti visi vienumi.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Nav atlas\u012Bts neviens vienums",
    one: () => "Atlas\u012Bto vienumu skaits: ".concat(formatter.number(args.count)),
    other: () => "Atlas\u012Bto vienumu skaits: ".concat(formatter.number(args.count))
  }), "."),
  "selectedItem": args => "Atlas\u012Bts vienums ".concat(args.item, ".")
};
var $d0ae97c9412add8b$exports = {};
$d0ae97c9412add8b$exports = {
  "deselectedItem": args => "".concat(args.item, " er ikke valgt."),
  "longPressToSelect": "Bruk et langt trykk for \xE5 g\xE5 inn i valgmodus.",
  "select": "Velg",
  "selectedAll": "Alle elementer er valgt.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Ingen elementer er valgt",
    one: () => "".concat(formatter.number(args.count), " element er valgt"),
    other: () => "".concat(formatter.number(args.count), " elementer er valgt")
  }), "."),
  "selectedItem": args => "".concat(args.item, " er valgt.")
};
var $7e5335510891b8c3$exports = {};
$7e5335510891b8c3$exports = {
  "deselectedItem": args => "".concat(args.item, " niet geselecteerd."),
  "longPressToSelect": "Druk lang om de selectiemodus te openen.",
  "select": "Selecteren",
  "selectedAll": "Alle items geselecteerd.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Geen items geselecteerd",
    one: () => "".concat(formatter.number(args.count), " item geselecteerd"),
    other: () => "".concat(formatter.number(args.count), " items geselecteerd")
  }), "."),
  "selectedItem": args => "".concat(args.item, " geselecteerd.")
};
var $455cb5ebd5f6c27d$exports = {};
$455cb5ebd5f6c27d$exports = {
  "deselectedItem": args => "Nie zaznaczono ".concat(args.item, "."),
  "longPressToSelect": "Naci\u015Bnij i przytrzymaj, aby wej\u015B\u0107 do trybu wyboru.",
  "select": "Zaznacz",
  "selectedAll": "Wszystkie zaznaczone elementy.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Nie zaznaczono \u017Cadnych element\xF3w",
    one: () => "".concat(formatter.number(args.count), " zaznaczony element"),
    other: () => "".concat(formatter.number(args.count), " zaznaczonych element\xF3w")
  }), "."),
  "selectedItem": args => "Zaznaczono ".concat(args.item, ".")
};
var $55020c522ee676a2$exports = {};
$55020c522ee676a2$exports = {
  "deselectedItem": args => "".concat(args.item, " n\xE3o selecionado."),
  "longPressToSelect": "Mantenha pressionado para entrar no modo de sele\xE7\xE3o.",
  "select": "Selecionar",
  "selectedAll": "Todos os itens selecionados.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Nenhum item selecionado",
    one: () => "".concat(formatter.number(args.count), " item selecionado"),
    other: () => "".concat(formatter.number(args.count), " itens selecionados")
  }), "."),
  "selectedItem": args => "".concat(args.item, " selecionado.")
};
var $cc691e0f35e41c7f$exports = {};
$cc691e0f35e41c7f$exports = {
  "deselectedItem": args => "".concat(args.item, " n\xE3o selecionado."),
  "longPressToSelect": "Prima continuamente para entrar no modo de sele\xE7\xE3o.",
  "select": "Selecionar",
  "selectedAll": "Todos os itens selecionados.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Nenhum item selecionado",
    one: () => "".concat(formatter.number(args.count), " item selecionado"),
    other: () => "".concat(formatter.number(args.count), " itens selecionados")
  }), "."),
  "selectedItem": args => "".concat(args.item, " selecionado.")
};
var $712b70af9d7e11e9$exports = {};
$712b70af9d7e11e9$exports = {
  "deselectedItem": args => "".concat(args.item, " neselectat."),
  "longPressToSelect": "Ap\u0103sa\u021Bi lung pentru a intra \xEEn modul de selectare.",
  "select": "Selectare",
  "selectedAll": "Toate elementele selectate.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Niciun element selectat",
    one: () => "".concat(formatter.number(args.count), " element selectat"),
    other: () => "".concat(formatter.number(args.count), " elemente selectate")
  }), "."),
  "selectedItem": args => "".concat(args.item, " selectat.")
};
var $c483d9d6d4bcff75$exports = {};
$c483d9d6d4bcff75$exports = {
  "deselectedItem": args => "".concat(args.item, " \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E."),
  "longPressToSelect": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438 \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430 \u0432 \u0440\u0435\u0436\u0438\u043C \u0432\u044B\u0431\u043E\u0440\u0430.",
  "select": "\u0412\u044B\u0431\u0440\u0430\u0442\u044C",
  "selectedAll": "\u0412\u044B\u0431\u0440\u0430\u043D\u044B \u0432\u0441\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u041D\u0435\u0442 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432",
    one: () => "".concat(formatter.number(args.count), " \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u0432\u044B\u0431\u0440\u0430\u043D"),
    other: () => "".concat(formatter.number(args.count), " \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u0432\u044B\u0431\u0440\u0430\u043D\u043E")
  }), "."),
  "selectedItem": args => "".concat(args.item, " \u0432\u044B\u0431\u0440\u0430\u043D\u043E.")
};
var $35bc9f18e7cf9157$exports = {};
$35bc9f18e7cf9157$exports = {
  "deselectedItem": args => "Nevybrat\xE9 polo\u017Eky: ".concat(args.item, "."),
  "longPressToSelect": "Dlh\u0161\xEDm stla\u010Den\xEDm prejdite do re\u017Eimu v\xFDberu.",
  "select": "Vybra\u0165",
  "selectedAll": "V\u0161etky vybrat\xE9 polo\u017Eky.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u017Diadne vybrat\xE9 polo\u017Eky",
    one: () => "".concat(formatter.number(args.count), " vybrat\xE1 polo\u017Eka"),
    other: () => "Po\u010Det vybrat\xFDch polo\u017Eiek:".concat(formatter.number(args.count))
  }), "."),
  "selectedItem": args => "Vybrat\xE9 polo\u017Eky: ".concat(args.item, ".")
};
var $e933d1373d8e91e0$exports = {};
$e933d1373d8e91e0$exports = {
  "deselectedItem": args => "Element ".concat(args.item, " ni izbran."),
  "longPressToSelect": "Za izbirni na\u010Din pritisnite in dlje \u010Dasa dr\u017Eite.",
  "select": "Izberite",
  "selectedAll": "Vsi elementi so izbrani.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Noben element ni izbran",
    one: () => "".concat(formatter.number(args.count), " element je izbran"),
    other: () => "".concat(formatter.number(args.count), " elementov je izbranih")
  }), "."),
  "selectedItem": args => "Element ".concat(args.item, " je izbran.")
};
var $77463d6521c72512$exports = {};
$77463d6521c72512$exports = {
  "deselectedItem": args => "".concat(args.item, " nije izabrano."),
  "longPressToSelect": "Dugo pritisnite za ulazak u re\u017Eim biranja.",
  "select": "Izaberite",
  "selectedAll": "Izabrane su sve stavke.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Nije izabrana nijedna stavka",
    one: () => "Izabrana je ".concat(formatter.number(args.count), " stavka"),
    other: () => "Izabrano je ".concat(formatter.number(args.count), " stavki")
  }), "."),
  "selectedItem": args => "".concat(args.item, " je izabrano.")
};
var $6380ab044222ca52$exports = {};
$6380ab044222ca52$exports = {
  "deselectedItem": args => "".concat(args.item, " ej markerat."),
  "longPressToSelect": "Tryck l\xE4nge n\xE4r du vill \xF6ppna v\xE4ljarl\xE4ge.",
  "select": "Markera",
  "selectedAll": "Alla markerade objekt.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Inga markerade objekt",
    one: () => "".concat(formatter.number(args.count), " markerat objekt"),
    other: () => "".concat(formatter.number(args.count), " markerade objekt")
  }), "."),
  "selectedItem": args => "".concat(args.item, " markerat.")
};
var $9cb854f23a6ff322$exports = {};
$9cb854f23a6ff322$exports = {
  "deselectedItem": args => "".concat(args.item, " se\xE7ilmedi."),
  "longPressToSelect": "Se\xE7im moduna girmek i\xE7in uzun bas\u0131n.",
  "select": "Se\xE7",
  "selectedAll": "T\xFCm \xF6geler se\xE7ildi.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "Hi\xE7bir \xF6ge se\xE7ilmedi",
    one: () => "".concat(formatter.number(args.count), " \xF6ge se\xE7ildi"),
    other: () => "".concat(formatter.number(args.count), " \xF6ge se\xE7ildi")
  }), "."),
  "selectedItem": args => "".concat(args.item, " se\xE7ildi.")
};
var $912862d79e063c74$exports = {};
$912862d79e063c74$exports = {
  "deselectedItem": args => "".concat(args.item, " \u043D\u0435 \u0432\u0438\u0431\u0440\u0430\u043D\u043E."),
  "longPressToSelect": "\u0412\u0438\u043A\u043E\u043D\u0430\u0439\u0442\u0435 \u0434\u043E\u0432\u0433\u0435 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u043D\u043D\u044F, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0440\u0435\u0436\u0438\u043C \u0432\u0438\u0431\u043E\u0440\u0443.",
  "select": "\u0412\u0438\u0431\u0440\u0430\u0442\u0438",
  "selectedAll": "\u0423\u0441\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u043E.",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u0416\u043E\u0434\u043D\u0438\u0445 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432 \u043D\u0435 \u0432\u0438\u0431\u0440\u0430\u043D\u043E",
    one: () => "".concat(formatter.number(args.count), " \u0435\u043B\u0435\u043C\u0435\u043D\u0442 \u0432\u0438\u0431\u0440\u0430\u043D\u043E"),
    other: () => "\u0412\u0438\u0431\u0440\u0430\u043D\u043E \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432: ".concat(formatter.number(args.count))
  }), "."),
  "selectedItem": args => "".concat(args.item, " \u0432\u0438\u0431\u0440\u0430\u043D\u043E.")
};
var $91bb887772fd7ad4$exports = {};
$91bb887772fd7ad4$exports = {
  "deselectedItem": args => "\u672A\u9009\u62E9 ".concat(args.item, "\u3002"),
  "longPressToSelect": "\u957F\u6309\u4EE5\u8FDB\u5165\u9009\u62E9\u6A21\u5F0F\u3002",
  "select": "\u9009\u62E9",
  "selectedAll": "\u5DF2\u9009\u62E9\u6240\u6709\u9879\u76EE\u3002",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u672A\u9009\u62E9\u9879\u76EE",
    one: () => "\u5DF2\u9009\u62E9 ".concat(formatter.number(args.count), " \u4E2A\u9879\u76EE"),
    other: () => "\u5DF2\u9009\u62E9 ".concat(formatter.number(args.count), " \u4E2A\u9879\u76EE")
  }), "\u3002"),
  "selectedItem": args => "\u5DF2\u9009\u62E9 ".concat(args.item, "\u3002")
};
var $a33ce76c4b030d83$exports = {};
$a33ce76c4b030d83$exports = {
  "deselectedItem": args => "\u672A\u9078\u53D6\u300C".concat(args.item, "\u300D\u3002"),
  "longPressToSelect": "\u9577\u6309\u4EE5\u9032\u5165\u9078\u64C7\u6A21\u5F0F\u3002",
  "select": "\u9078\u53D6",
  "selectedAll": "\u5DF2\u9078\u53D6\u6240\u6709\u9805\u76EE\u3002",
  "selectedCount": (args, formatter) => "".concat(formatter.plural(args.count, {
    "=0": "\u672A\u9078\u53D6\u4EFB\u4F55\u9805\u76EE",
    one: () => "\u5DF2\u9078\u53D6 ".concat(formatter.number(args.count), " \u500B\u9805\u76EE"),
    other: () => "\u5DF2\u9078\u53D6 ".concat(formatter.number(args.count), " \u500B\u9805\u76EE")
  }), "\u3002"),
  "selectedItem": args => "\u5DF2\u9078\u53D6\u300C".concat(args.item, "\u300D\u3002")
};
$085250522aa37816$exports = {
  "ar-AE": $6f42661ae0214332$exports,
  "bg-BG": $3e5d289b19f0fad9$exports,
  "cs-CZ": $786c35956e916979$exports,
  "da-DK": $7166f564b8fa3e8a$exports,
  "de-DE": $12fc5e32bb482de0$exports,
  "el-GR": $84b67ad15c785b2c$exports,
  "en-US": $86f7e6ba2423a35d$exports,
  "es-ES": $67f524d2f2545d56$exports,
  "et-EE": $d8df13f1dbf6e0c4$exports,
  "fi-FI": $e2b4dfe2d4d55739$exports,
  "fr-FR": $c06d6698d30993e7$exports,
  "he-IL": $e775713aa5566057$exports,
  "hr-HR": $a972cfeb69a51f5b$exports,
  "hu-HU": $a471da6bb87e6cd1$exports,
  "it-IT": $47879155027d6c95$exports,
  "ja-JP": $9cd8dc003c2209e6$exports,
  "ko-KR": $a490b9448c5f2ded$exports,
  "lt-LT": $99f69e0597841328$exports,
  "lv-LV": $28ac5b31e47d46d4$exports,
  "nb-NO": $d0ae97c9412add8b$exports,
  "nl-NL": $7e5335510891b8c3$exports,
  "pl-PL": $455cb5ebd5f6c27d$exports,
  "pt-BR": $55020c522ee676a2$exports,
  "pt-PT": $cc691e0f35e41c7f$exports,
  "ro-RO": $712b70af9d7e11e9$exports,
  "ru-RU": $c483d9d6d4bcff75$exports,
  "sk-SK": $35bc9f18e7cf9157$exports,
  "sl-SI": $e933d1373d8e91e0$exports,
  "sr-SP": $77463d6521c72512$exports,
  "sv-SE": $6380ab044222ca52$exports,
  "tr-TR": $9cb854f23a6ff322$exports,
  "uk-UA": $912862d79e063c74$exports,
  "zh-CN": $91bb887772fd7ad4$exports,
  "zh-TW": $a33ce76c4b030d83$exports
};
function $1eb174acfe8a0f16$export$137e594ef3218a10(props, state) {
  var _state_collection_getTextValue;
  let {
    getRowText = key => {
      var _state_collection, _state_collection_getTextValue1, _state_collection_getItem;
      return (_state_collection_getTextValue = (_state_collection_getTextValue1 = (_state_collection = state.collection).getTextValue) === null || _state_collection_getTextValue1 === void 0 ? void 0 : _state_collection_getTextValue1.call(_state_collection, key)) !== null && _state_collection_getTextValue !== void 0 ? _state_collection_getTextValue : (_state_collection_getItem = state.collection.getItem(key)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.textValue;
    }
  } = props;
  let stringFormatter = (0, $2oePb$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($085250522aa37816$exports)));
  // Many screen readers do not announce when items in a grid are selected/deselected.
  // We do this using an ARIA live region.
  let selection = state.selectionManager.rawSelection;
  let lastSelection = (0, $2oePb$react.useRef)(selection);
  (0, $2oePb$reactariautils.useUpdateEffect)(() => {
    var _lastSelection_current;
    if (!state.selectionManager.isFocused) {
      lastSelection.current = selection;
      return;
    }
    let addedKeys = $1eb174acfe8a0f16$var$diffSelection(selection, lastSelection.current);
    let removedKeys = $1eb174acfe8a0f16$var$diffSelection(lastSelection.current, selection);
    // If adding or removing a single row from the selection, announce the name of that item.
    let isReplace = state.selectionManager.selectionBehavior === "replace";
    let messages = [];
    if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
      if (state.collection.getItem(state.selectionManager.selectedKeys.keys().next().value)) {
        let currentSelectionText = getRowText(state.selectionManager.selectedKeys.keys().next().value);
        if (currentSelectionText) messages.push(stringFormatter.format("selectedItem", {
          item: currentSelectionText
        }));
      }
    } else if (addedKeys.size === 1 && removedKeys.size === 0) {
      let addedText = getRowText(addedKeys.keys().next().value);
      if (addedText) messages.push(stringFormatter.format("selectedItem", {
        item: addedText
      }));
    } else if (removedKeys.size === 1 && addedKeys.size === 0) {
      if (state.collection.getItem(removedKeys.keys().next().value)) {
        let removedText = getRowText(removedKeys.keys().next().value);
        if (removedText) messages.push(stringFormatter.format("deselectedItem", {
          item: removedText
        }));
      }
    }
    // Announce how many items are selected, except when selecting the first item.
    if (state.selectionManager.selectionMode === "multiple") {
      if (messages.length === 0 || selection === "all" || selection.size > 1 || lastSelection.current === "all" || ((_lastSelection_current = lastSelection.current) === null || _lastSelection_current === void 0 ? void 0 : _lastSelection_current.size) > 1) messages.push(selection === "all" ? stringFormatter.format("selectedAll") : stringFormatter.format("selectedCount", {
        count: selection.size
      }));
    }
    if (messages.length > 0) (0, $2oePb$reactarialiveannouncer.announce)(messages.join(" "));
    lastSelection.current = selection;
  }, [selection]);
}
function $1eb174acfe8a0f16$var$diffSelection(a, b) {
  let res = new Set();
  if (a === "all" || b === "all") return res;
  for (let key of a.keys()) if (!b.has(key)) res.add(key);
  return res;
}

/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $340f2fcd0ef9ce8d$export$be42ebdab07ae4c2(props) {
  let stringFormatter = (0, $2oePb$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($085250522aa37816$exports)));
  let modality = (0, $2oePb$reactariainteractions.useInteractionModality)();
  // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
  let shouldLongPress = (modality === "pointer" || modality === "virtual" || modality == null) && typeof window !== "undefined" && "ontouchstart" in window;
  let interactionDescription = (0, $2oePb$react.useMemo)(() => {
    let selectionMode = props.selectionManager.selectionMode;
    let selectionBehavior = props.selectionManager.selectionBehavior;
    let message = undefined;
    if (shouldLongPress) message = stringFormatter.format("longPressToSelect");
    return selectionBehavior === "replace" && selectionMode !== "none" && props.hasItemActions ? message : undefined;
  }, [props.selectionManager.selectionMode, props.selectionManager.selectionBehavior, props.hasItemActions, stringFormatter, shouldLongPress]);
  let descriptionProps = (0, $2oePb$reactariautils.useDescription)(interactionDescription);
  return descriptionProps;
}
function $11d770dfabe45077$export$f6b86a04e5d66d90(props, state, ref) {
  let {
    isVirtualized: isVirtualized,
    keyboardDelegate: keyboardDelegate,
    focusMode: focusMode,
    scrollRef: scrollRef,
    getRowText: getRowText,
    onRowAction: onRowAction,
    onCellAction: onCellAction
  } = props;
  let {
    selectionManager: manager
  } = state;
  if (!props["aria-label"] && !props["aria-labelledby"]) console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
  // When virtualized, the layout object will be passed in as a prop and override this.
  let collator = (0, $2oePb$reactariai18n.useCollator)({
    usage: "search",
    sensitivity: "base"
  });
  let {
    direction: direction
  } = (0, $2oePb$reactariai18n.useLocale)();
  let disabledBehavior = state.selectionManager.disabledBehavior;
  let delegate = (0, $2oePb$react.useMemo)(() => keyboardDelegate || new (0, $3187c0e19200cb16$export$de9feff04fda126e)({
    collection: state.collection,
    disabledKeys: disabledBehavior === "selection" ? new Set() : state.disabledKeys,
    ref: ref,
    direction: direction,
    collator: collator,
    focusMode: focusMode
  }), [keyboardDelegate, state.collection, state.disabledKeys, disabledBehavior, ref, direction, collator, focusMode]);
  let {
    collectionProps: collectionProps
  } = (0, $2oePb$reactariaselection.useSelectableCollection)({
    ref: ref,
    selectionManager: manager,
    keyboardDelegate: delegate,
    isVirtualized: isVirtualized,
    scrollRef: scrollRef
  });
  let id = (0, $2oePb$reactariautils.useId)(props.id);
  (0, $8ee34951196858d0$export$e6235c0d09b995d0).set(state, {
    keyboardDelegate: delegate,
    actions: {
      onRowAction: onRowAction,
      onCellAction: onCellAction
    }
  });
  let descriptionProps = (0, $340f2fcd0ef9ce8d$export$be42ebdab07ae4c2)({
    selectionManager: manager,
    hasItemActions: !!(onRowAction || onCellAction)
  });
  let domProps = (0, $2oePb$reactariautils.filterDOMProps)(props, {
    labelable: true
  });
  let onFocus = (0, $2oePb$react.useCallback)(e => {
    if (manager.isFocused) {
      // If a focus event bubbled through a portal, reset focus state.
      if (!e.currentTarget.contains(e.target)) manager.setFocused(false);
      return;
    }
    // Focus events can bubble through portals. Ignore these events.
    if (!e.currentTarget.contains(e.target)) return;
    manager.setFocused(true);
  }, [manager]);
  // Continue to track collection focused state even if keyboard navigation is disabled
  let navDisabledHandlers = (0, $2oePb$react.useMemo)(() => ({
    onBlur: collectionProps.onBlur,
    onFocus: onFocus
  }), [onFocus, collectionProps.onBlur]);
  let hasTabbableChild = (0, $2oePb$reactariafocus.useHasTabbableChild)(ref, {
    isDisabled: state.collection.size !== 0
  });
  let gridProps = (0, $2oePb$reactariautils.mergeProps)(domProps, {
    role: "grid",
    id: id,
    "aria-multiselectable": manager.selectionMode === "multiple" ? "true" : undefined
  }, state.isKeyboardNavigationDisabled ? navDisabledHandlers : collectionProps,
  // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
  state.collection.size === 0 && {
    tabIndex: hasTabbableChild ? -1 : 0
  }, descriptionProps);
  if (isVirtualized) {
    gridProps["aria-rowcount"] = state.collection.size;
    gridProps["aria-colcount"] = state.collection.columnCount;
  }
  (0, $1eb174acfe8a0f16$export$137e594ef3218a10)({
    getRowText: getRowText
  }, state);
  return {
    gridProps: gridProps
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $c7def85a57100898$export$d3037f5d3f3e51bf() {
  return {
    rowGroupProps: {
      role: "rowgroup"
    }
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $eed398987c639831$export$96357d5a73f686fa(props, state, ref) {
  let {
    node: node,
    isVirtualized: isVirtualized,
    shouldSelectOnPressUp: shouldSelectOnPressUp,
    onAction: onAction
  } = props;
  let {
    actions: {
      onRowAction: onRowAction
    }
  } = (0, $8ee34951196858d0$export$e6235c0d09b995d0).get(state);
  let {
    itemProps: itemProps,
    ...states
  } = (0, $2oePb$reactariaselection.useSelectableItem)({
    selectionManager: state.selectionManager,
    key: node.key,
    ref: ref,
    isVirtualized: isVirtualized,
    shouldSelectOnPressUp: shouldSelectOnPressUp,
    onAction: onRowAction ? () => onRowAction(node.key) : onAction,
    isDisabled: state.collection.size === 0
  });
  let isSelected = state.selectionManager.isSelected(node.key);
  let rowProps = {
    role: "row",
    "aria-selected": state.selectionManager.selectionMode !== "none" ? isSelected : undefined,
    "aria-disabled": states.isDisabled || undefined,
    ...itemProps
  };
  if (isVirtualized) rowProps["aria-rowindex"] = node.index + 1; // aria-rowindex is 1 based
  return {
    rowProps: rowProps,
    ...states
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $cf2021be63b01ef4$export$c7e10bfc0c59f67c(props, state, ref) {
  let {
    node: node,
    isVirtualized: isVirtualized,
    focusMode = "child",
    shouldSelectOnPressUp: shouldSelectOnPressUp,
    onAction: onAction
  } = props;
  let {
    direction: direction
  } = (0, $2oePb$reactariai18n.useLocale)();
  let {
    keyboardDelegate: keyboardDelegate,
    actions: {
      onCellAction: onCellAction
    }
  } = (0, $8ee34951196858d0$export$e6235c0d09b995d0).get(state);
  // We need to track the key of the item at the time it was last focused so that we force
  // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
  let keyWhenFocused = (0, $2oePb$react.useRef)(null);
  // Handles focusing the cell. If there is a focusable child,
  // it is focused, otherwise the cell itself is focused.
  let focus = () => {
    let treeWalker = (0, $2oePb$reactariafocus.getFocusableTreeWalker)(ref.current);
    if (focusMode === "child") {
      // If focus is already on a focusable child within the cell, early return so we don't shift focus
      if (ref.current.contains(document.activeElement) && ref.current !== document.activeElement) return;
      let focusable = state.selectionManager.childFocusStrategy === "last" ? $cf2021be63b01ef4$var$last(treeWalker) : treeWalker.firstChild();
      if (focusable) {
        (0, $2oePb$reactariafocus.focusSafely)(focusable);
        return;
      }
    }
    if (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current.contains(document.activeElement)) (0, $2oePb$reactariafocus.focusSafely)(ref.current);
  };
  let {
    itemProps: itemProps,
    isPressed: isPressed
  } = (0, $2oePb$reactariaselection.useSelectableItem)({
    selectionManager: state.selectionManager,
    key: node.key,
    ref: ref,
    isVirtualized: isVirtualized,
    focus: focus,
    shouldSelectOnPressUp: shouldSelectOnPressUp,
    onAction: onCellAction ? () => onCellAction(node.key) : onAction,
    isDisabled: state.collection.size === 0
  });
  let onKeyDownCapture = e => {
    if (!e.currentTarget.contains(e.target) || state.isKeyboardNavigationDisabled) return;
    let walker = (0, $2oePb$reactariafocus.getFocusableTreeWalker)(ref.current);
    walker.currentNode = document.activeElement;
    switch (e.key) {
      case "ArrowLeft":
        {
          // Find the next focusable element within the cell.
          let focusable = direction === "rtl" ? walker.nextNode() : walker.previousNode();
          // Don't focus the cell itself if focusMode is "child"
          if (focusMode === "child" && focusable === ref.current) focusable = null;
          if (focusable) {
            e.preventDefault();
            e.stopPropagation();
            (0, $2oePb$reactariafocus.focusSafely)(focusable);
            (0, $2oePb$reactariautils.scrollIntoViewport)(focusable, {
              containingElement: (0, $2oePb$reactariautils.getScrollParent)(ref.current)
            });
          } else {
            // If there is no next focusable child, then move to the next cell to the left of this one.
            // This will be handled by useSelectableCollection. However, if there is no cell to the left
            // of this one, only one column, and the grid doesn't focus rows, then the next key will be the
            // same as this one. In that case we need to handle focusing either the cell or the first/last
            // child, depending on the focus mode.
            let prev = keyboardDelegate.getKeyLeftOf(node.key);
            if (prev !== node.key) break;
            e.preventDefault();
            e.stopPropagation();
            if (focusMode === "cell" && direction === "rtl") {
              (0, $2oePb$reactariafocus.focusSafely)(ref.current);
              (0, $2oePb$reactariautils.scrollIntoViewport)(ref.current, {
                containingElement: (0, $2oePb$reactariautils.getScrollParent)(ref.current)
              });
            } else {
              walker.currentNode = ref.current;
              focusable = direction === "rtl" ? walker.firstChild() : $cf2021be63b01ef4$var$last(walker);
              if (focusable) {
                (0, $2oePb$reactariafocus.focusSafely)(focusable);
                (0, $2oePb$reactariautils.scrollIntoViewport)(focusable, {
                  containingElement: (0, $2oePb$reactariautils.getScrollParent)(ref.current)
                });
              }
            }
          }
          break;
        }
      case "ArrowRight":
        {
          let focusable = direction === "rtl" ? walker.previousNode() : walker.nextNode();
          if (focusMode === "child" && focusable === ref.current) focusable = null;
          if (focusable) {
            e.preventDefault();
            e.stopPropagation();
            (0, $2oePb$reactariafocus.focusSafely)(focusable);
            (0, $2oePb$reactariautils.scrollIntoViewport)(focusable, {
              containingElement: (0, $2oePb$reactariautils.getScrollParent)(ref.current)
            });
          } else {
            let next = keyboardDelegate.getKeyRightOf(node.key);
            if (next !== node.key) break;
            e.preventDefault();
            e.stopPropagation();
            if (focusMode === "cell" && direction === "ltr") {
              (0, $2oePb$reactariafocus.focusSafely)(ref.current);
              (0, $2oePb$reactariautils.scrollIntoViewport)(ref.current, {
                containingElement: (0, $2oePb$reactariautils.getScrollParent)(ref.current)
              });
            } else {
              walker.currentNode = ref.current;
              focusable = direction === "rtl" ? $cf2021be63b01ef4$var$last(walker) : walker.firstChild();
              if (focusable) {
                (0, $2oePb$reactariafocus.focusSafely)(focusable);
                (0, $2oePb$reactariautils.scrollIntoViewport)(focusable, {
                  containingElement: (0, $2oePb$reactariautils.getScrollParent)(ref.current)
                });
              }
            }
          }
          break;
        }
      case "ArrowUp":
      case "ArrowDown":
        // Prevent this event from reaching cell children, e.g. menu buttons. We want arrow keys to navigate
        // to the cell above/below instead. We need to re-dispatch the event from a higher parent so it still
        // bubbles and gets handled by useSelectableCollection.
        if (!e.altKey && ref.current.contains(e.target)) {
          e.stopPropagation();
          e.preventDefault();
          ref.current.parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
        }
        break;
    }
  };
  // Grid cells can have focusable elements inside them. In this case, focus should
  // be marshalled to that element rather than focusing the cell itself.
  let onFocus = e => {
    keyWhenFocused.current = node.key;
    if (e.target !== ref.current) {
      // useSelectableItem only handles setting the focused key when
      // the focused element is the gridcell itself. We also want to
      // set the focused key when a child element receives focus.
      // If focus is currently visible (e.g. the user is navigating with the keyboard),
      // then skip this. We want to restore focus to the previously focused row/cell
      // in that case since the table should act like a single tab stop.
      if (!(0, $2oePb$reactariainteractions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
      return;
    }
    // If the cell itself is focused, wait a frame so that focus finishes propagatating
    // up to the tree, and move focus to a focusable child if possible.
    requestAnimationFrame(() => {
      if (focusMode === "child" && document.activeElement === ref.current) focus();
    });
  };
  let gridCellProps = (0, $2oePb$reactariautils.mergeProps)(itemProps, {
    role: "gridcell",
    onKeyDownCapture: onKeyDownCapture,
    onFocus: onFocus
  });
  var _node_colIndex;
  if (isVirtualized) gridCellProps["aria-colindex"] = ((_node_colIndex = node.colIndex) !== null && _node_colIndex !== void 0 ? _node_colIndex : node.index) + 1; // aria-colindex is 1-based
  // When pressing with a pointer and cell selection is not enabled, usePress will be applied to the
  // row rather than the cell. However, when the row is draggable, usePress cannot preventDefault
  // on pointer down, so the browser will try to focus the cell which has a tabIndex applied.
  // To avoid this, remove the tabIndex from the cell briefly on pointer down.
  if (shouldSelectOnPressUp && gridCellProps.tabIndex != null && gridCellProps.onPointerDown == null) gridCellProps.onPointerDown = e => {
    let el = e.currentTarget;
    let tabindex = el.getAttribute("tabindex");
    el.removeAttribute("tabindex");
    requestAnimationFrame(() => {
      el.setAttribute("tabindex", tabindex);
    });
  };
  return {
    gridCellProps: gridCellProps,
    isPressed: isPressed
  };
}
function $cf2021be63b01ef4$var$last(walker) {
  let next;
  let last;
  do {
    last = walker.lastChild();
    if (last) next = last;
  } while (last);
  return next;
}
function $d8385f73d3701365$export$70e2eed1a92976ad(props, state) {
  let {
    key: key
  } = props;
  let manager = state.selectionManager;
  let checkboxId = (0, $2oePb$reactariautils.useId)();
  let isDisabled = !state.selectionManager.canSelectItem(key);
  let isSelected = state.selectionManager.isSelected(key);
  let onChange = () => manager.select(key);
  const stringFormatter = (0, $2oePb$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($085250522aa37816$exports)));
  return {
    checkboxProps: {
      id: checkboxId,
      "aria-label": stringFormatter.format("select"),
      isSelected: isSelected,
      isDisabled: isDisabled,
      onChange: onChange
    }
  };
}